import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ReactNode } from "react";
import { cn } from "@verse_core/shared_components/ClassName";
import { faTriangleExclamation } from "@fortawesome/free-solid-svg-icons";

/** Red error text with a warning icon, for a field or a whole form. */
export function ErrorMessage({
  id,
  role,
  className,
  children,
}: {
  id?: string;
  role?: "alert";
  className?: string;
  children: ReactNode;
}) {
  return (
    <p
      id={id}
      role={role}
      className={cn(
        "tw-m-0 tw-flex tw-items-start tw-gap-[4px] tw-font-sohne tw-text-[14px] tw-leading-[1.4] tw-text-verse-text-critical",
        className,
      )}
    >
      <FontAwesomeIcon
        icon={faTriangleExclamation}
        aria-hidden="true"
        // Lines the icon up with the first line when the text wraps.
        className="tw-mt-[2px] tw-h-[16px] tw-w-[16px] tw-shrink-0"
      />
      {children}
    </p>
  );
}
